<template>
  <div class="reports-per-country-n-stream">
    <div class="columns is-multiline is-desktop">
      <h3 class="column is-4">Reports per stream and country</h3>
      <div class="column">
        <div class="columns is-multiline is-desktop is-align-item-center">
          <div class="merge-all-stream-checkbox column">
            <b-field>
              <b-checkbox
                v-model="countryCheckbox"
                native-value="false"
                @click.native="getUnAssignedCountries"
              >
                Merge all streams
              </b-checkbox>
            </b-field>
          </div>
          <div class="analytics-datepicker column is-align-item-center">
            <label>From </label>
            <b-datepicker
              class="analytics-date-picker actual-submission-start-date"
              v-model="from_date"
              required
              icon="calendar-today"
              trap-focus
              v-on:input="getByDate"
            >
            </b-datepicker>

            <label>To </label>
            <b-datepicker
              class="analytics-date-picker"
              v-model="to_date"
              position="is-bottom-left"
              required
              icon="calendar-today"
              trap-focus
              v-on:input="getByDate"
            >
            </b-datepicker>
          </div>
          <div class="analytices-countrylist column">
            <b-dropdown
              v-model="selectedCountries"
              multiple
              ref="dropdownCountry"
              aria-role="list"
              @change="checkCountry($event)"
              class="is-float-right"
            >
              <button class="button is-primary" type="button" slot="trigger">
                <span>Countries ({{ selectedCountries.length }})</span>
                <b-icon icon="menu-down"></b-icon>
              </button>

              <b-dropdown-item
                custom
                aria-role="listitem"
                v-for="(country, index) in dropdownCountries"
                :value="country"
                :key="index"
              >
                <b-checkbox
                  @input="$refs.dropdownCountry.selectItem(country)"
                  value="true"
                >
                  <span>{{ country }}</span>
                </b-checkbox>
              </b-dropdown-item>
            </b-dropdown>
            <b-loading
              :is-full-page="isFullPage"
              v-model="isLoading"
              :can-cancel="true"
            >
              <b-icon icon="loading" size="is-large"> </b-icon>
            </b-loading>
          </div>
        </div>
      </div>
    </div>
    <div id="chart" class="chart">
      <apexchart
        v-if="series.length > 0 && chartOptions"
        type="bar"
        height="450"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import utitlityMixin from "@/mixins/UtilityMixin";
import analyticsSerice from "@/services/AnalyticsService";
// @group Analytics
export default {
  name: "AnalyticsView",
  mixins: [utitlityMixin],
  data() {
    return {
      country: null,
      loadingComponent: null,
      isLoading: false,
      isFullPage: true,
      from_date: this.sixMonthsBefore(),
      to_date: this.currentDate(),
      switchCustomerId: null,
      analyticsSerice: new analyticsSerice(),
      countryCheckbox: false,
      series: [],
      mseries: [],
      originalSeries: [],
      chartOptions: {},
      countryList: [],
      selectedCountries: [],
      dropdownCountries: []
    };
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    this.fetchReportsTotalCount();
  },
  methods: {
    checkCountry(event) {
      if (event.length != 0) {
        this.countryCheckbox = false;
        this.isLoading = true;
        let initialSeries = JSON.parse(JSON.stringify(this.mseries));
        event.sort();
        const countryIndex = this.findPositions(this.dropdownCountries, event);

        for (const v of initialSeries) {
          const a_new = v.data.filter((e, i) => countryIndex.includes(i));
          v.data = a_new;
        }
        this.series = initialSeries;
        initialSeries = [];
        this.chartOptions = {
          xaxis: {
            type: "text",
            categories: event
          }
        };
        this.isLoading = false;
      } else {
        this.selectedCountries = -1;
        this.series = [];
        this.chartOptions = {
          xaxis: {
            type: "text",
            categories: this.dropdownCountries
          }
        };
      }
    },
    doNothing(a) {
      return a;
    },
    findPositions(first, second) {
      const indicies = [];
      first.forEach((element, index) => {
        if (second.includes(element)) {
          indicies.push(index);
        }
      });
      return indicies;
    },
    getByDate() {
      this.countryCheckbox = false;
      this.fetchReportsTotalCount();
    },
    getUnAssignedCountries() {
      if (this.countryCheckbox == false) {
        const sumofSeries = this.getSumofStreams(this.series);
        const newSeries = {};
        newSeries["data"] = sumofSeries;
        const newArr = [];
        newArr.push(newSeries);
        newArr[0]["name"] = "all";
        this.series = newArr;
      } else {
        this.series = this.originalSeries;
      }
    },
    getSumofStreams(series) {
      const mergedSeries = series[0]["data"].map((x, idx) =>
        series.reduce((sum, curr) => sum + curr["data"][idx], 0)
      );
      return mergedSeries;
    },
    fetchReportsTotalCount() {
      const start_date = this.dateFormatterNew(this.from_date);
      const end_date = this.dateFormatterNew(this.to_date);

      if (start_date != null && end_date != null && start_date >= end_date) {
        alert("end date should be greater than start date");
        return false;
      }
      this.analyticsSerice
        .getReportPerCountryStream(
          this.switchCustomerId,
          this.dateFormatterNew(this.from_date),
          this.dateFormatterNew(this.to_date),
          this.selectedCountries
        )
        .subscribe(
          response => {
            this.countryList = response["country_list"];
            this.selectedCountries = response["country_list"];
            this.dropdownCountries = response["all_countries"];
            this.series = response["reports"];
            this.mseries = Object.assign(response["reports"]);

            this.originalSeries = response["reports"];
            this.chartOptions = {
              chart: {
                type: "bar",
                height: 450
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  dataLabels: {
                    position: "top"
                  }
                }
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                show: true,
                width: 1,
                colors: ["#fff"]
              },
              tooltip: {
                shared: true,
                intersect: false
              },
              xaxis: {
                type: "text",
                categories: this.countryList
              },
              legend: {
                showForSingleSeries: true,
                showForNullSeries: true,
                showForZeroSeries: true,
                position: "top",
                colors: ["#FF8000", "#00d1b2"]
              },
              noData: {
                text: "Sorry, No Data for the selected",
                align: "center",
                verticalAlign: "middle",
                offsetX: 0,
                offsetY: 0
              }
            };
            this.isLoading = false;
          },
          error => {
            console.log("error loading data");
          }
        );
    }
  }
};
</script>
